var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Classificação cutter","titleIcon":"fas fa-hashtag"}},[_c('catalogo-crud',{attrs:{"tipo":"cutter","rotuloNovo":"NOVO CUTTER","nomeSingular":"cutter","placeholderBusca":"Pesquisar por código ou descrição","campos":_vm.campos,"colunas":_vm.colunas,"dialogLargura":"520px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }